import { CSSProperties } from 'react';
import Image from 'next/image';
import { Box } from '@/lib/mui';

export const preferencesImageStyle = {
  overflow: 'hidden',
  borderRadius: 20,
  display: 'flex',
  flexShrink: 0,
  margin: '0 10px',
  alignItems: 'center',
  boxShadow: '0 4px 10px rgba(0,0,0,0.25)',
};

const imageStyle: CSSProperties = {
  objectFit: 'cover',
};

const width = {
  xs: 100,
  sm: 127,
};

const height = {
  xs: 100,
  sm: 127,
};

export function CapImage() {
  return (
    <Box
      width={width}
      height={height}
      style={{
        ...preferencesImageStyle,
        background: '#e8524f',
      }}
    >
      <Image
        style={imageStyle}
        src="/cap.png"
        alt="cap"
        width="140"
        height="90"
      />
    </Box>
  );
}

export function ControllerImage() {
  return (
    <Box
      width={width}
      height={height}
      style={{
        ...preferencesImageStyle,
        background: '#0bc5ff',
      }}
    >
      <Image
        style={{ ...imageStyle, marginLeft: 30 }}
        src="/controller.png"
        alt="controller"
        width="158"
        height="97"
      />
    </Box>
  );
}

export function ShoesImage() {
  return (
    <Box
      width={width}
      height={height}
      style={{
        ...preferencesImageStyle,
        background: '#a757d9',
      }}
    >
      <Image
        style={{ ...imageStyle, transform: 'scaleX(-1)', marginLeft: -50 }}
        src="/shoes.png"
        alt="shoes"
        width="165"
        height="70"
      />
    </Box>
  );
}

export function LipstickImage() {
  return (
    <Box
      width={width}
      height={height}
      style={{
        ...preferencesImageStyle,
        background: '#ffc480',
      }}
    >
      <Image
        style={{
          ...imageStyle,
          transform: 'rotate(65.176deg)',
          marginTop: 45,
          marginLeft: 20,
        }}
        src="/lipstick.png"
        alt="lipstick"
        width="97"
        height="135"
      />
    </Box>
  );
}

export function Lipstick2Image() {
  return (
    <Box
      width={width}
      height={height}
      style={{
        ...preferencesImageStyle,
        background: '#ffc480',
      }}
    >
      <Image
        style={{
          ...imageStyle,
          transform: 'rotate(30.176deg)',
          marginLeft: 47,
          marginTop: 47,
        }}
        src="/lipstick2.png"
        alt="lipstick"
        width="34"
        height="160"
      />
    </Box>
  );
}

export function SpeakersImage() {
  return (
    <Box
      width={width}
      height={height}
      style={{
        ...preferencesImageStyle,
        background: '#11d6af',
        justifyContent: 'center',
      }}
    >
      <Image
        style={{ ...imageStyle, marginTop: 35 }}
        src="/speakers.png"
        alt="speakers"
        width="49"
        height="134"
      />
    </Box>
  );
}
